// Open «حجز جديد» OVER the current hotel page — `openReservationPanel()` from
// the hotel top bar, rendered by <ReservationPanelHost/> (mounted once by the
// shell in a hotel session). The deep link /hotel/reservations/new renders its
// own panel over the tape.

import { createElement, useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { NewReservationPanel } from './screens/NewReservationPanel';

interface HostState {
  open: boolean;
  /** Bumped per open so a re-open starts a fresh panel. */
  seq: number;
}

type Listener = () => void;
let state: HostState = { open: false, seq: 0 };
const listeners = new Set<Listener>();
const emit = () => listeners.forEach((l) => l());

export const reservationPanelStore = {
  get: (): HostState => state,
  open(): void {
    state = { open: true, seq: state.seq + 1 };
    emit();
  },
  close(): void {
    if (!state.open) return;
    state = { ...state, open: false };
    emit();
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  /** Test hook. */
  reset(): void {
    state = { open: false, seq: 0 };
    emit();
  },
};

export function openReservationPanel(): void {
  reservationPanelStore.open();
}

/** The deep link renders its own panel over the tape: the host never opens a second one beside it. */
const DEEP_LINK = '/hotel/reservations/new';

export function ReservationPanelHost() {
  const st = useSyncExternalStore(reservationPanelStore.subscribe, reservationPanelStore.get, reservationPanelStore.get);
  const onDeepLink = useLocation().pathname === DEEP_LINK;
  // «حجز جديد» pressed while the deep link's panel is open must not reappear when that one closes
  useEffect(() => {
    if (onDeepLink) reservationPanelStore.close();
  }, [onDeepLink, st.open]);
  return createElement(NewReservationPanel, { key: st.seq, open: st.open && !onDeepLink, onClose: reservationPanelStore.close });
}
